import { apiSlice, defaultTransformFn } from 'api/apiSlice'
import { AIPlanBlueprintPreview } from 'api/entities/AIPlanBlueprintPreview'

const BASE_URL = 'aiPlanBlueprints'

const aiPlanBlueprintsTags = apiSlice.enhanceEndpoints({
  addTagTypes: ['AIPlanBlueprint']
})

export const aiPlanBlueprintsApi = aiPlanBlueprintsTags.injectEndpoints({
  endpoints: builder => ({
    getAIPlanBlueprint: builder.query<AIPlanBlueprintPreview, { publicId: string }>({
      query: ({ publicId }) => ({
        url: `${BASE_URL}/${publicId}`,
        method: 'GET',
        isContext: true,
        isAgency: false
      }),
      providesTags: (_result, _error, request) => [{ type: 'AIPlanBlueprint', id: request.publicId }],
      transformResponse: defaultTransformFn
    })
  })
})

export const { useGetAIPlanBlueprintQuery } = aiPlanBlueprintsApi
